<template>
    <div class="eventCards__header-item f1 d-flex align-items-center justify-content-center" :class="bgColor">
        <div v-if="icon" class="mr-2 icon --large" :class="iconImg"></div>
        <div class="c-white">{{ label }}</div>
    </div>
</template>

<script>

    export default {
        name: 'EventCardHeaderItem',
        props: {
            color: {
                type: String,
                required: true,
            },
            icon: {
                type: String,
                required: false,
                default: ''
            },
            label: {
                type: String,
                required: true,
            },
        },

        computed: {
            bgColor() {
                return `bg-${this.color}`;
            },
            iconImg() {
                return this.icon ? `--${this.icon}` : null;
            }
        }
    }

</script>
